import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

/**
 * Short in-app educational/professional-use disclaimer banner.
 * Drop near AI-generated content (analysis results, SOAP drafts, PDF reports).
 */
export default function DisclaimerBanner({ className = "" }) {
  return (
    <div
      data-testid="disclaimer-banner"
      className={`flex items-start gap-3 bg-terracotta-500/5 border border-terracotta-500/20 rounded-2xl px-4 py-3 ${className}`}
    >
      <ShieldAlert className="w-4 h-4 text-terracotta-500 shrink-0 mt-0.5" strokeWidth={1.75} />
      <p className="text-xs text-ink-700 leading-relaxed">
        For educational and documentation support only. Posturra does not diagnose medical conditions
        or replace licensed medical evaluation. Always use independent professional judgment.{" "}
        <Link to="/disclaimer" className="text-terracotta-600 underline-offset-2 hover:underline" data-testid="disclaimer-banner-link">
          Read full disclaimer
        </Link>
      </p>
    </div>
  );
}
